import { App as AntApp, Col, Row, Upload } from "antd";
import { RcFile } from "antd/lib/upload";
import { useTranslation } from "react-i18next";
import { HttpContentType } from "../../../../common/api/http";
import ActionButton from "../../../../common/components/buttons/ActionButton";
import { FileUploadAccept, rowGutter, SMALL_MAX_FILE_SIZE_MB } from "../../../../common/constants";
import { CalcAttachmentType } from "../enums";

interface Props {
  type: CalcAttachmentType;
  onChange: (type: CalcAttachmentType, file?: RcFile) => void;
}

export const CalcAttachmentUpload = ({ type, onChange }: Props) => {
  const { t } = useTranslation();
  const { notification } = AntApp.useApp();

  const handleFileUpload = (file: RcFile) => {
    if (!HttpContentType.PDF.includes(file.type)) {
      notification.error({
        title: t("common.error"),
        description: t("calc.helpers.unsupportedAttachmentType"),
      });

      return Upload.LIST_IGNORE;
    }

    const isFileSizeAllowed = file.size / 1024 / 1024 < SMALL_MAX_FILE_SIZE_MB;

    if (!isFileSizeAllowed) {
      notification.error({
        title: t("common.error"),
        description: t("validation.unsupportedAttachmentSize", { size: SMALL_MAX_FILE_SIZE_MB }),
      });

      return Upload.LIST_IGNORE;
    }

    onChange(type, file);
    return false;
  };

  const handleFileRemove = () => {
    onChange(type);
    return true;
  };

  return (
    <Row gutter={rowGutter}>
      <Col span={10}>
        <b>{t("calc.enums.calcAttachmentType." + type)}:</b>
      </Col>

      <Col span={14}>
        <Upload maxCount={1} accept={FileUploadAccept.PDF} beforeUpload={handleFileUpload} onRemove={handleFileRemove}>
          <ActionButton icon="plus">{t("common.add")}</ActionButton>
        </Upload>
      </Col>
    </Row>
  );
};
